class Common {
    constructor(){

    }

inEmpatyObject(obj){
    if(obj===null) return true
    else return JSON.stringify(obj)==='{}'
}

isEmpty(x){
    return (                                                           //don't put newline after return
        (typeof x == 'undefined')
              ||
        (x == null)
              ||
        (x == false)        //same as: !x
              ||
        (x.length == 0)
              ||
        (x == 0)            // note this line, you might not need this. 
              ||
        (x == "")
              ||
        (!/[^\s]/.test(x))
              ||
        (/^\s*$/.test(x))
    );
}


getUserStatus(type){
    if(type===1) return 'Active'
    else return 'InActive'
}

}
export default new Common